import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  Tabs,
  Tab,
  // InputLabel,
  // Select,
  // MenuItem,
  // FormControl,
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getVendorById, updateVendor, deleteVendor } from "../../api/vendor";
import { handleAxiosError } from "../../config/action-config";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import { vendorPurchaseTable } from "../../config/grid-columns-defs";
import { showAlert } from "../../actions/alert";

const deleteApis = {
  VENDOR: deleteVendor,
  // 'TASK': deleteTask,
  // 'EMPLOYEE': deleteEmployee,
};

const emptyVendorData = {
  billing_address: "",
  city: "",
  company_name: "",
  contact: "",
  country: "",
  creation_date: "",
  currency: "",
  email: "",
  postal_code: "",
  shipping_address: "",
  state: "",
  vendor_name: "",
  id: "",
};

export default function ViewVendor() {
  const rowHeight = 38;
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorData] = useState(emptyVendorData);
  const [purchases, setPurchases] = useState([]);

  const [tabIndex, setTabIndex] = useState(0);

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);
  const onVendorDataUpdate = () => {
    updateVendor(vendorData.id, getUpdatableVendorData(vendorData), user.token)
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const loadMasterData = () => {
    getVendorById(params.id, user.token)
      .then((res) => {
        setVendorData(res.data.data.vendor);
        setPurchases(res.data.data.purchases);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else loadMasterData();
  }, [params.id]);

  const changeUpdateData = (e) => {
    setVendorData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "VENDOR") {
          navigate("/vendors");
        }
        // else if (deletingContent.table === 'EMPLOYEE') { loadMasterData(); }
        // else if (deletingContent.table == 'TASK') { loadTimesheetData(); }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };

  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Vendor Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({ table: "VENDOR", row: vendorData.id });
              }}
              className="blue-button"
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="vendor_name"
              onChange={changeUpdateData}
              value={vendorData.vendor_name}
              size="small"
              label="Name"
              className="name-textfeild"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="contact"
              onChange={changeUpdateData}
              value={vendorData.contact}
              error={!/^[0-9]{10}$/.test(vendorData.contact)}
              inputProps={{ maxLength: 10 }}
              size="small"
              label="Contact"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="email"
              onChange={changeUpdateData}
              value={vendorData.email}
              size="small"
              label="Email"
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="company_name"
              onChange={changeUpdateData}
              value={vendorData.company_name}
              size="small"
              label="Company"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="currency"
              onChange={changeUpdateData}
              value={vendorData.currency}
              size="small"
              label="Currency"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="city"
              onChange={changeUpdateData}
              value={vendorData.city}
              size="small"
              label="City"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="postal_code"
              onChange={changeUpdateData}
              value={vendorData.postal_code}
              size="small"
              label="Postal Code"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              fullWidth
              name="state"
              onChange={changeUpdateData}
              value={vendorData.state}
              size="small"
              label="State"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            <TextField
              fullWidth
              name="country"
              onChange={changeUpdateData}
              value={vendorData.country}
              size="small"
              label="Country"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <TextField
              fullWidth
              name="shipping_address"
              onChange={changeUpdateData}
              value={vendorData.shipping_address}
              size="small"
              label="Shipping Address"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <TextField
              fullWidth
              name="billing_address"
              onChange={changeUpdateData}
              value={vendorData.billing_address}
              size="small"
              label="Billing Address"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                size="small"
                inputFormat="MM/dd/yyyy"
                label="Start Date"
                value={vendorData.creation_date}
                disabled={true}
                onChange={() => {}}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            {editDisabled ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  disabled={/^Trial_User$/i.test(user.role) ? true : false}
                  variant="contained"
                  onClick={onVendorDataUpdate}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Purchase Orders"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          {/* <Box sx={{ display: 'flex', columnGap: 1, p: 2, borderBottom: 1 }}>
                            <Button variant='contained' style={{ padding: '5px 7px' }} onClick={onAddProjectClick} >Assign Project</Button>
                            {
                                Boolean(selectedProjectRow) ? <Button variant='contained' style={{ padding: '5px 7px' }}
                                    onClick={() => { setDeletingContent({ table: "PROJECT", row: selectedProjectRow }) }}
                                >Delete Selected</Button> : <></>
                            }
                        </Box> */}
          {/* <div className="ag-theme-material" style={{ height: "300px" }}> */}
          <div className="ag-theme-material pmt-controll-table">
            <AgGridReact
              columnDefs={vendorPurchaseTable}
              rowData={purchases}
              rowSelection="single"
              domLayout="autoHeight"
              headerHeight="38"
              rowHeight={rowHeight}
              // onRowClicked={(params) => { setSelectedProjectRow(params.data.ep_id) }}
            />
          </div>
        </Paper>
      </TabPanel>

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  const user = useSelector((state) => state.user);
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          onClick={onDelete}
          autoFocus
          className="blue-button"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableVendorData(data) {
  return {
    billing_address: data.billing_address,
    city: data.city,
    company_name: data.company_name,
    contact: data.contact,
    country: data.country,
    currency: data.currency,
    email: data.email,
    postal_code: data.postal_code,
    shipping_address: data.shipping_address,
    state: data.state,
    vendor_name: data.vendor_name,
  };
}
